import { isFunction, toEventWithLocalDates, toViewWithLocalDates, task, resourceBackgroundColor, resourceTextColor, createEventClasses, createEventContent, keyEnter, setContent, datesEqual, outsideRange, toISOString, sortEventChunks, addDay, cloneDate, bgEvent, eventIntersects, createEventChunk, setPayload, btnTextDay, themeView, btnTextWeek, btnTextMonth, btnTextYear, intl } from '@kokoro-calendar/core';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { getContext, onMount, afterUpdate } from 'svelte';

var root$1 = $.template(`<article><div></div> <div></div></article>`);

function Event($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $resources = () => $.store_get(resources, '$resources', $$stores);
	const $eventBackgroundColor = () => $.store_get(eventBackgroundColor, '$eventBackgroundColor', $$stores);
	const $eventColor = () => $.store_get(eventColor, '$eventColor', $$stores);
	const $eventTextColor = () => $.store_get(eventTextColor, '$eventTextColor', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $eventClassNames = () => $.store_get(eventClassNames, '$eventClassNames', $$stores);
	const $_view = () => $.store_get(_view, '$_view', $$stores);
	const $displayEventEnd = () => $.store_get(displayEventEnd, '$displayEventEnd', $$stores);
	const $eventContent = () => $.store_get(eventContent, '$eventContent', $$stores);
	const $_intlEventTime = () => $.store_get(_intlEventTime, '$_intlEventTime', $$stores);
	const $eventDidMount = () => $.store_get(eventDidMount, '$eventDidMount', $$stores);
	const $eventAllUpdated = () => $.store_get(eventAllUpdated, '$eventAllUpdated', $$stores);
	const $eventClick = () => $.store_get(eventClick, '$eventClick', $$stores);
	const $eventMouseEnter = () => $.store_get(eventMouseEnter, '$eventMouseEnter', $$stores);
	const $eventMouseLeave = () => $.store_get(eventMouseLeave, '$eventMouseLeave', $$stores);
	const $_interaction = () => $.store_get(_interaction, '$_interaction', $$stores);
	let chunk = $.prop($$props, 'chunk', 8);

	let {
		displayEventEnd,
		eventAllUpdated,
		eventBackgroundColor,
		eventTextColor,
		eventColor,
		eventContent,
		eventClassNames,
		eventClick,
		eventDidMount,
		eventMouseEnter,
		eventMouseLeave,
		resources,
		theme,
		_view,
		_intlEventTime,
		_interaction,
		_tasks
	} = getContext('state');

	let el = $.mutable_state();
	let event = $.mutable_state();
	let classes = $.mutable_state();
	let style = $.mutable_state();
	let content = $.mutable_state();
	let timeText = $.mutable_state();
	let onclick = $.mutable_state();

	onMount(() => {
		if (isFunction($eventDidMount())) {
			$eventDidMount()({
				event: toEventWithLocalDates($.get(event)),
				timeText: $.get(timeText),
				el: $.get(el),
				view: toViewWithLocalDates($_view())
			});
		}
	});

	afterUpdate(() => {
		if (isFunction($eventAllUpdated())) {
			task(() => $eventAllUpdated()({ view: toViewWithLocalDates($_view()) }), 'eau', _tasks);
		}
	});

	function createHandler(fn) {
		return isFunction(fn)
			? (jsEvent) => fn({
				event: toEventWithLocalDates($.get(event)),
				el: $.get(el),
				jsEvent,
				view: toViewWithLocalDates($_view())
			})
			: undefined;
	}

	$.legacy_pre_effect(() => ($.deep_read_state(chunk())), () => {
		$.set(event, chunk().event);
	});

	$.legacy_pre_effect(
		() => (
			$.get(style),
			$.get(event),
			$resources(),
			$eventBackgroundColor(),
			$eventColor(),
			$eventTextColor(),
			$theme(),
			$eventClassNames(),
			$_view()
		),
		() => {
			// Class & Style
			$.set(style, '');

			let bgColor = $.get(event).backgroundColor || resourceBackgroundColor($.get(event), $resources()) || $eventBackgroundColor() || $eventColor();

			if (bgColor) {
				$.set(style, `background-color:${bgColor};`);
			}

			let txtColor = $.get(event).textColor || resourceTextColor($.get(event), $resources()) || $eventTextColor();

			if (txtColor) {
				$.set(style, $.get(style) + `color:${txtColor};`);
			}

			$.set(style, $.get(style) + $.get(event).styles.join(';'));

			$.set(classes, [
				$theme().event,
				...createEventClasses($eventClassNames(), $.get(event), $_view())
			].join(' '));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(timeText),
			$.get(content),
			$.deep_read_state(chunk()),
			$displayEventEnd(),
			$eventContent(),
			$theme(),
			$_intlEventTime(),
			$_view()
		),
		() => {
			// Content
			(($$value) => (
				$.set(timeText, $$value[0]),
				$.set(content, $$value[1])
			))(createEventContent(chunk(), $displayEventEnd(), $eventContent(), $theme(), $_intlEventTime(), $_view()));
		}
	);

	$.legacy_pre_effect(() => ($eventClick()), () => {
		$.set(onclick, createHandler($eventClick()));
	});

	$.legacy_pre_effect_reset();
	$.init();

	var article = root$1();
	var event_handler = $.derived(() => $.get(onclick) && keyEnter($.get(onclick)));
	var event_handler_1 = $.derived(() => createHandler($eventMouseEnter()));
	var event_handler_2 = $.derived(() => createHandler($eventMouseLeave()));
	var div = $.child(article);
	var div_1 = $.sibling(div, 2);

	$.action(div_1, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $.get(content));
	$.reset(article);
	$.bind_this(article, ($$value) => $.set(el, $$value), () => $.get(el));

	$.template_effect(() => {
		$.set_class(article, $.get(classes));
		$.set_attribute(article, 'role', $.get(onclick) ? 'button' : undefined);
		$.set_attribute(article, 'tabindex', $.get(onclick) ? 0 : undefined);
		$.set_class(div, $theme().eventTag);
		$.set_attribute(div, 'style', $.get(style));
		$.set_class(div_1, $theme().eventBody);
	});

	$.event('click', article, function (...$$args) {
		$.get(onclick)?.apply(this, $$args);
	});

	$.event('keydown', article, function (...$$args) {
		$.get(event_handler)?.apply(this, $$args);
	});

	$.event('mouseenter', article, function (...$$args) {
		$.get(event_handler_1)?.apply(this, $$args);
	});

	$.event('mouseleave', article, function (...$$args) {
		$.get(event_handler_2)?.apply(this, $$args);
	});

	$.event('pointerdown', article, function (...$$args) {
		$_interaction().action?.noAction?.apply(this, $$args);
	});

	$.append($$anchor, article);
	$.pop();
	$$cleanup();
}

var root_1$1 = $.template(`<div role="listitem"><h4><time></time> <time></time></h4> <!></div>`);

function Day($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $_today = () => $.store_get(_today, '$_today', $$stores);
	const $highlightedDates = () => $.store_get(highlightedDates, '$highlightedDates', $$stores);
	const $validRange = () => $.store_get(validRange, '$validRange', $$stores);
	const $_events = () => $.store_get(_events, '$_events', $$stores);
	const $filterEventsWithResources = () => $.store_get(filterEventsWithResources, '$filterEventsWithResources', $$stores);
	const $resources = () => $.store_get(resources, '$resources', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_interaction = () => $.store_get(_interaction, '$_interaction', $$stores);
	const $_intlListDay = () => $.store_get(_intlListDay, '$_intlListDay', $$stores);
	const $_intlListDaySide = () => $.store_get(_intlListDaySide, '$_intlListDaySide', $$stores);
	let date = $.prop($$props, 'date', 8);

	let {
		_events,
		_interaction,
		_intlListDay,
		_intlListDaySide,
		_today,
		resources,
		filterEventsWithResources,
		highlightedDates,
		theme,
		validRange
	} = getContext('state');

	let el = $.mutable_state();
	let chunks = $.mutable_state([]);

	let isToday = $.mutable_state(),
		highlight = $.mutable_state(),
		disabled = $.mutable_state();

	let datetime = $.mutable_state();

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(date()),
			$_today()
		),
		() => {
			$.set(isToday, datesEqual(date(), $_today()));
		}
	);

	$.legacy_pre_effect(
		() => (
			$highlightedDates(),
			$.deep_read_state(date())
		),
		() => {
			$.set(highlight, $highlightedDates().some((d) => datesEqual(d, date())));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(date()),
			$validRange()
		),
		() => {
			$.set(disabled, outsideRange(date(), $validRange()));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(date())
		),
		() => {
			$.set(datetime, toISOString(date(), 10));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(disabled),
			$.get(chunks),
			$.deep_read_state(date()),
			$_events(),
			$filterEventsWithResources(),
			$resources(),
			sortEventChunks
		),
		() => {
			if (!$.get(disabled)) {
				$.set(chunks, []);

				let start = date();
				let end = addDay(cloneDate(date()));

				for (let event of $_events()) {
					if (!bgEvent(event.display) && eventIntersects(event, start, end, $filterEventsWithResources() ? $resources() : undefined)) {
						let chunk = createEventChunk(event, start, end);

						$.get(chunks).push(chunk);
					}
				}

				sortEventChunks($.get(chunks));
			}
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(el),
			$.deep_read_state(date()),
			$.get(disabled)
		),
		() => {
			if ($.get(el)) {
				setPayload($.get(el), () => ({
					allDay: true,
					date: date(),
					resource: undefined,
					dayEl: $.get(el),
					disabled: $.get(disabled)
				}));
			}
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var div = root_1$1();
			var h4 = $.child(div);
			var time = $.child(h4);

			$.action(time, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $_intlListDay().format(date()));

			var time_1 = $.sibling(time, 2);

			$.action(time_1, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $_intlListDaySide().format(date()));
			$.reset(h4);

			var node_1 = $.sibling(h4, 2);

			$.each(node_1, 1, () => $.get(chunks), (chunk) => chunk.event, ($$anchor, chunk) => {
				Event($$anchor, {
					get chunk() {
						return $.get(chunk);
					}
				});
			});

			$.reset(div);
			$.bind_this(div, ($$value) => $.set(el, $$value), () => $.get(el));

			$.template_effect(
				($0) => {
					$.set_class(div, `${$theme().day ?? ''} ${$0 ?? ''}${($.get(isToday) ? ' ' + $theme().today : '') ?? ''}${($.get(highlight) ? ' ' + $theme().highlight : '') ?? ''}`);
					$.set_class(h4, $theme().dayHead);
					$.set_attribute(time, 'datetime', $.get(datetime));
					$.set_class(time_1, $theme().daySide);
					$.set_attribute(time_1, 'datetime', $.get(datetime));
				},
				[
					() => $theme().weekdays?.[date().getUTCDay()]
				],
				$.derived_safe_equal
			);

			$.event('pointerdown', div, function (...$$args) {
				$_interaction().action?.select?.apply(this, $$args);
			});

			$.append($$anchor, div);
		};

		$.if(node, ($$render) => {
			if ($.get(chunks).length) $$render(consequent);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
	$$cleanup();
}

var root_1 = $.template(`<div></div>`);
var root = $.template(`<div><div><!></div></div>`);

function Body($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $_viewDates = () => $.store_get(_viewDates, '$_viewDates', $$stores);
	const $_events = () => $.store_get(_events, '$_events', $$stores);
	const $noEventsContent = () => $.store_get(noEventsContent, '$noEventsContent', $$stores);
	const $noEventsClick = () => $.store_get(noEventsClick, '$noEventsClick', $$stores);
	const $_view = () => $.store_get(_view, '$_view', $$stores);
	const $_bodyEl = () => $.store_get(_bodyEl, '$_bodyEl', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);

	let {
		_bodyEl,
		_events,
		_view,
		_viewDates,
		noEventsClick,
		noEventsContent,
		theme
	} = getContext('state');

	let noEvents = $.mutable_state(),
		content = $.mutable_state();

	function handleClick(jsEvent) {
		if (isFunction($noEventsClick())) {
			$noEventsClick()({
				jsEvent,
				view: toViewWithLocalDates($_view())
			});
		}
	}

	$.legacy_pre_effect(
		() => (
			$_viewDates(),
			$_events(),
			bgEvent
		),
		() => {
			$.set(noEvents, true);

			if ($_viewDates().length) {
				let start = $_viewDates()[0];
				let end = addDay(cloneDate($_viewDates().at(-1)));

				for (let event of $_events()) {
					if (!bgEvent(event.display) && event.start < end && event.end > start) {
						$.set(noEvents, false);
						break;
					}
				}
			}
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(content),
			$noEventsContent()
		),
		() => {
			$.set(content, isFunction($noEventsContent()) ? $noEventsContent()() : $noEventsContent());

			if (typeof $.get(content) === 'string') {
				$.set(content, { html: $.get(content) });
			}
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var div = root();
	var div_1 = $.child(div);
	var node = $.child(div_1);

	{
		var consequent = ($$anchor) => {
			var div_2 = root_1();

			$.action(div_2, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $.get(content));
			$.effect(() => $.event('click', div_2, handleClick));
			$.template_effect(() => $.set_class(div_2, $theme().noEvents));
			$.append($$anchor, div_2);
		};

		var alternate = ($$anchor) => {
			var fragment = $.comment();
			var node_1 = $.first_child(fragment);

			$.each(node_1, 1, $_viewDates, $.index, ($$anchor, date) => {
				Day($$anchor, {
					get date() {
						return $.get(date);
					}
				});
			});

			$.append($$anchor, fragment);
		};

		$.if(node, ($$render) => {
			if ($.get(noEvents)) $$render(consequent); else $$render(alternate, false);
		});
	}

	$.reset(div_1);
	$.reset(div);
	$.bind_this(div, ($$value) => $.store_set(_bodyEl, $$value), () => $_bodyEl());

	$.template_effect(() => {
		$.set_class(div, $theme().body);
		$.set_class(div_1, $theme().content);
	});

	$.append($$anchor, div);
	$.pop();
	$$cleanup();
}

function View($$anchor) {
	Body($$anchor, {});
}

var index = {
	createOptions(options) {
		// Common options
		options.buttonText.listDay = 'list';
		options.buttonText.listWeek = 'list';
		options.buttonText.listMonth = 'list';
		options.buttonText.listYear = 'list';
		options.listDayFormat = { weekday: 'long' };
		options.listDaySideFormat = { year: 'numeric', month: 'long', day: 'numeric' };
		options.noEventsClick = undefined;  // ec option
		options.noEventsContent = 'No events';
		options.theme.daySide = 'ec-day-side';
		options.theme.eventTag = 'ec-event-tag';
		options.theme.noEvents = 'ec-no-events';
		options.view = 'listWeek';
		options.views.listDay = {
			buttonText: btnTextDay,
			component: View,
			duration: { days: 1 },
			theme: themeView('ec-list ec-day-view')
		};
		options.views.listWeek = {
			buttonText: btnTextWeek,
			component: View,
			duration: { weeks: 1 },
			theme: themeView('ec-list ec-week-view')
		};
		options.views.listMonth = {
			buttonText: btnTextMonth,
			component: View,
			duration: { months: 1 },
			theme: themeView('ec-list ec-month-view')
		};
		options.views.listYear = {
			buttonText: btnTextYear,
			component: View,
			duration: { years: 1 },
			theme: themeView('ec-list ec-year-view')
		};
	},

	createStores(state) {
		state._intlListDay = intl(state.locale, state.listDayFormat);
		state._intlListDaySide = intl(state.locale, state.listDaySideFormat);
	}
};

export { index as default };
